import { render, staticRenderFns } from "./CloseButtonSetting.vue?vue&type=template&id=0b1e8bc3&"
import script from "./CloseButtonSetting.vue?vue&type=script&lang=ts&"
export * from "./CloseButtonSetting.vue?vue&type=script&lang=ts&"
import style0 from "./CloseButtonSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports